const CommentSeparator = () => <div className="mt-8 mb-4 mx-2" />;

export default CommentSeparator;
